import React from "react";
import { useApp } from "@/context/AppProvider";
import { Reveal } from "@/components/motion";
import { EditableText, ListControls, AddButton } from "@/components/editable";
import { TEMPLATES } from "@/content";

export const Manifesto = () => {
  const { tr, ed, editMode, moveItem, removeItem, addItem } = useApp();
  const path = ["manifesto", "chapters"];
  const chapters = tr.manifesto.chapters;

  return (
    <section id="about" data-testid="manifesto" className="relative py-24 md:py-32 lg:py-40" style={{ backgroundColor: "var(--bone)" }}>
      <div className="container-lux">
        <Reveal>
          <EditableText as="p" path={["manifesto", "eyebrow"]} value={tr.manifesto.eyebrow} className="eyebrow mb-4 inline-block" />
        </Reveal>
        <div className="grid md:grid-cols-3 gap-x-12 gap-y-16 mt-10">
          {chapters.map((c, i) => (
            <Reveal key={i} delay={i * 0.12}>
              <div className={`relative ${editMode ? "editing-outline" : ""}`}>
                {editMode && (
                  <ListControls
                    className="absolute -top-3 end-0"
                    onUp={() => moveItem(path, i, -1)}
                    onDown={() => moveItem(path, i, 1)}
                    onDelete={() => removeItem(path, i)}
                    canUp={i > 0}
                    canDown={i < chapters.length - 1}
                    testid={`manifesto-controls-${i}`}
                  />
                )}
                <EditableText as="span" path={[...path, i, "n"]} value={c.n} className="font-display text-6xl md:text-7xl block mb-6" style={{ color: "rgba(197,160,89,0.55)" }} />
                <EditableText as="h3" path={[...path, i, "title"]} value={c.title} className="font-display text-2xl md:text-3xl mb-4 leading-snug" style={{ color: "var(--ink)" }} />
                <EditableText as="p" multiline path={[...path, i, "body"]} value={c.body} className="font-body text-base leading-relaxed" style={{ color: "var(--ink-soft)" }} />
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-10">
          <AddButton onClick={() => addItem(path, TEMPLATES.manifestoChapter.en, TEMPLATES.manifestoChapter.ar)} label={ed.addItem} testid="add-manifesto" />
        </div>
      </div>
    </section>
  );
};
